import { useTranslate } from "@similarweb/i18n-provider";
import { Badge, Type } from "@similarweb/ui-components";

import appsSearchI18nKeys from "app/pages/sales-intelligence/modules/apps-search/utils/i18n";
import { appOsToStoreMap } from "app/pages/sales-intelligence/modules/apps-search-filters/constants";
import solutionUrlsService from "app/pages/sales-intelligence/services/solution-urls";

import type { IBaseAppsRowDto } from "../../../types/rows";

import { StyledCell, StyledContent, StyledCombinedIcon, StyledTooltipTextAnchorCell } from "./styles";

type Props = {
    value: IBaseAppsRowDto["app"];
    row: IBaseAppsRowDto;
};

const AppNameCell = ({ value, row }: Props) => {
    const { translate } = useTranslate();

    return (
        <StyledCell dataAutomation="app-name-cell">
            <StyledContent $withBadge={row.is_new}>
                <StyledCombinedIcon
                    type="itemIcon"
                    iconType={Type.Website}
                    iconSrc={row.icon}
                />

                <StyledTooltipTextAnchorCell
                    fontVariant="input2"
                    href={solutionUrlsService.getAppAnalysisUrl(row.app_id, appOsToStoreMap[row.market])}
                    target="_blank"
                    tooltipContent={translate(appsSearchI18nKeys.cell.appLinkTooltipText)}
                >
                    {value}
                </StyledTooltipTextAnchorCell>
            </StyledContent>

            {row.is_new ? <Badge type="new" /> : null}
        </StyledCell>
    );
};

export default AppNameCell;
